import MobxDragFile from './MobxDragFile'

export default MobxDragFile
